import { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { TimeReportingProjectMemberFormViewProps } from "models/propTypes/timeReportingProjectPropTypes";
import { FormEnums } from "models/enums";
import { FormHandles, GenericFormSection } from "models/propTypes/genericFormProps";
import { TimeReportingProjectFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { GenericForm } from "components/common";
import useMemberGeneralFields from "./useMemberGeneralFields";
import useMemberRatesFields from "./useMemberRatesFields";
import useMemberSelfBillingFields from "./useMemberSelfBillingFields";
//#endregion

const TimeReportingProjectMemberForm: ForwardRefRenderFunction<FormHandles, TimeReportingProjectMemberFormViewProps> = (
  props,
  ref
) => {
  const projectMemberSettingsGeneralFields = useMemberGeneralFields(props);
  const projectMemberSettingsMemberFields = useMemberRatesFields(props);
  const projectMemberSettingsSelfBillingFields = useMemberSelfBillingFields(props);

  const formFieldsStep1: GenericFormSection<TimeReportingProjectFormTypes.ProjectMember>[] = [
    {
      label: TranslationKeys.TimeReportingProject.General,
      type: FormEnums.FormSectionType.SIMPLETAB,
      innerFields: projectMemberSettingsGeneralFields,
    },
  ];

  const formFieldsStep2: GenericFormSection<TimeReportingProjectFormTypes.ProjectMember>[] = [
    {
      label: TranslationKeys.TimeReportingProject.Rates,
      type: FormEnums.FormSectionType.SIMPLETAB,
      innerFields: projectMemberSettingsMemberFields,
      hidden: (values: TimeReportingProjectFormTypes.ProjectMember) =>
        !values.categories?.some((cm) => cm.selected) && (values.futureCategoryRates?.length ?? 0) === 0,
    },
  ];

  const formFieldsStep3: GenericFormSection<TimeReportingProjectFormTypes.ProjectMember>[] = [
    {
      label: TranslationKeys.TimeReportingProject.SelfBilling,
      type: FormEnums.FormSectionType.SIMPLETAB,
      innerFields: projectMemberSettingsSelfBillingFields,
    },
  ];

  return (
    <GenericForm
      formRef={ref}
      {...props}
      fields={formFieldsStep1.concat(formFieldsStep2).concat(formFieldsStep3)}
      hideSuccess
      enableControlLables
      formGridLayout={{ message: false }}
    />
  );
};

export default forwardRef(TimeReportingProjectMemberForm);
